"use strict";

exports.__esModule = true;
exports.mergeProps = mergeProps;
exports.mergeRefs = mergeRefs;

var _function = require("./function");

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function mergeProps() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (mergedProps, props) {
    var result = _extends({}, mergedProps);

    for (var propName in props) {
      var mergedValue = result[propName];
      var propValue = props[propName];

      if (propName === 'className' && typeof mergedValue === 'string' && typeof propValue === 'string') {
        result[propName] = (0, _clsx["default"])(mergedValue, propValue);
      } else if (propName === 'style') {
        result[propName] = _extends({}, mergedValue, propValue);
      } else if (typeof mergedValue === 'function' && typeof propValue === 'function' && /^on[A-Z]/.test(propName)) {
        result[propName] = (0, _function.chainCallbacks)(mergedValue, propValue);
      } else {
        result[propName] = propValue != null ? propValue : mergedValue;
      }
    }

    return result;
  }, {});
}

function mergeRefs() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }

  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}